import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";
import "./Navber.css";
import { useSelector } from "react-redux";


const AnimatedNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
const isHomePage = location.pathname === "/";
  const [expanded, setExpanded] = useState(false);
  const [activeLink, setActiveLink] = useState("");
  const [scrolled, setScrolled] = useState(false);
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  const navItems = [
    { label: "Properties", id: "properties" },
    { label: "Current Projects", id: "projects" },
    { label: "About Us", id: "about" },
    { label: "Contact Us", id: "contact" },
    { label: "Gallery", id: "gallery" },
  ];

  // Scroll background change
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <motion.div
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <Navbar
        expand="lg"
        expanded={expanded}
        fixed="top"
      className={`custom-navbar 
  ${scrolled || !isHomePage ? "navbar-scrolled" : ""}
`}
      >
        <Container>
          <Navbar.Brand
            className="nav-logo"
            onClick={() => navigate("/")}
          >
            RealEstate<span>LLP</span>
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setExpanded(expanded ? false : "expanded")}
          />

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto align-items-center gap-4">
              {navItems.map((item, index) => (
                <Nav.Link
                  key={index}
                  className={`nav-link-item ${
                    location.pathname.includes(item.id)
                      ? "nav-link-active"
                      : ""
                  }`}
                  onClick={() => {
                    navigate(`/${item.id}`);
                    setExpanded(false);
                  }}
                >
                  {item.label}
                </Nav.Link>
              ))}

              <Button
                className="book-now-btn"
                onClick={() => navigate("/properties")}
              >
                Book Now
              </Button>

               <div onClick={()=>{isAuthenticated?navigate("/profile"):navigate("/login")}}>
        <img src="/user.png"
        style={{backgroundColor:"#fefefe",borderRadius:"50%"}}/>
        </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </motion.div>
  );
};

export default AnimatedNavbar;